module.exports = __webpack_public_path__ + "img/6C.f4e900df.png";